import { render } from "./AiChatHistory.vue?vue&type=template&id=d5592eb2&scoped=true"
import script from "./AiChatHistory.vue?vue&type=script&lang=js"
export * from "./AiChatHistory.vue?vue&type=script&lang=js"

import "./AiChatHistory.vue?vue&type=style&index=0&id=d5592eb2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5592eb2"]])

export default __exports__